import { Component, Input } from '@angular/core';

@Component({
  selector: 'boi-message-result',
  templateUrl: './message-result.component.html',
  styleUrls: ['./message-result.component.scss']
})
export class MessageResultComponent {
  @Input() public htmlContent: string;
}
